import { render, staticRenderFns } from "./ModalDiscar.vue?vue&type=template&id=c5d4454e&scoped=true"
import script from "./ModalDiscar.vue?vue&type=script&lang=js"
export * from "./ModalDiscar.vue?vue&type=script&lang=js"
import style0 from "./ModalDiscar.vue?vue&type=style&index=0&id=c5d4454e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d4454e",
  null
  
)

export default component.exports